import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { DemoResultData, ExistingStudentConsumerCurriculumRegisterModel, PaymentProviderRequestResult } from '../../../Elearning-Models';
import { CurriculumService } from '../../../Services/curriculum.service';
import { IServiceFactory } from '../../../Services/service-factory';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { CurriculumRegisterParentPasswordComponent } from '../curriculum-register/curriculum-register-parent-password/curriculum-register-parent-password.component';
import { SimplePopupDialogComponent } from 'src/app/simple-popup-dialog/simple-popup-dialog.component';
import { stringToKeyValue } from '@angular/flex-layout/extended/typings/style/style-transforms';

@Component({
  selector: 'app-consumer-curriculum-diagnostic-marketing',
  templateUrl: './consumer-curriculum-diagnostic-marketing.component.html',
  styleUrls: ['./consumer-curriculum-diagnostic-marketing.component.scss']
})
export class ConsumerCurriculumDiagnosticMarketingComponent implements OnInit {
  dataService: CurriculumService;
  studentConsumerCurriculumID: number;
  demoResultData: DemoResultData;
  studentID: number;
  classID: number;
  totalLessons: number;
  demoDataAvailable: boolean = null;
  password: string  = null;

  constructor(
    private serviceFactory: IServiceFactory,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private router: Router
  ) {
    this.dataService = this.serviceFactory.getCurriculumService();
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.studentConsumerCurriculumID = +params.get('studentCurriculumID');
      this.studentID = +params.get('studentUserID');
      this.classID = +params.get('classID');


      if (!!this.studentConsumerCurriculumID){

        //check if they bought... if so, then redirect to currview

        this.dataService.GetDemoResultData(this.studentConsumerCurriculumID).subscribe(result => {
          if(result){
            this.demoResultData = result;
            var flooredCount = Math.floor(this.demoResultData.TotalLessons / 10) * 10;
            this.totalLessons = flooredCount == this.demoResultData.TotalLessons ? flooredCount - 10 : flooredCount;
            this.demoDataAvailable = true;
          }
        });
      }

      else if (!!this.studentID && !!this.classID){

        //check if they bought, if so then redirect to curr view
        
        this.dataService.GetDemoResultDataByStudentAndClass(this.studentID,this.classID).subscribe(result => {

          if(result){
            this.demoResultData = result;
            var flooredCount = Math.floor(this.demoResultData.TotalLessons / 10) * 10;
            this.totalLessons = flooredCount == this.demoResultData.TotalLessons ? flooredCount - 10 : flooredCount;
            this.demoDataAvailable = true;
          }
        });
      }
      
      else{
        this.demoDataAvailable = false;
      }
    });

  }


  getParentPassword(buyLevel: number) {
    const dialogRef = this.dialog.open(CurriculumRegisterParentPasswordComponent, {
      data: {
      },
    });

    const sub = dialogRef.componentInstance.valueUpdated.subscribe(
      (validated) => {
        if(validated){
          this.password = validated;
          this.assignAndPay(buyLevel);
        }
      });

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  }

  buyBasic(){
    this.buy(1);
  }

  buyFull(){
    this.buy(2)
  }

  buy(buyLevel: number){
    if(!this.demoDataAvailable){
      return;
    }

    if (this.demoResultData.IsStudent){
      this.getParentPassword(buyLevel);
    } else {
      this.assignAndPay(buyLevel)
    }
  }

  assignAndPay(buyLevel: number){
    var model = new ExistingStudentConsumerCurriculumRegisterModel();
    model.StudentConsumerCurriculumID = this.demoResultData.StudentConsumerCurriculumID;
    model.CurriculumProductLevelID = buyLevel;
    model.Password = this.password;

    this.dataService.AssignCurriculumByStudentConsumerCurriculumID(model).subscribe((res: PaymentProviderRequestResult) => {
      if (res.Success) {
        this.toastr.success('Curriculum Assigned.', 'Success!');
        window.location.href = res.RequestUrl;
      } else {
        //if success = false and requestURL != null then they already have paid for it, so reroute them to curr view page.
        if(res.RequestUrl != null){
          window.location.href = res.RequestUrl;
        } 
        else{
          this.toastr.error(res.ResultMessage, 'Failure!');
        }
      }
    });
  }

  getMoreInfo(row: number){
    var dialog: string;
    var title: string;
    switch(row){
      case 1:
      {
        dialog = "Rightpath Ascend provides a free, abbreviated diagnostic test. Basic and Premium subscribers benefit from a complete course diagnostic."+
         " Basic subscribers are required to complete the full diagnostic prior to taking lessons. Premium subscribers have the option to complete the full "+
         "diagnostic anytime or skip it entirely, and can also take the diagnostic more than once.";
        title = "Diagnostic Tests";
        break;
      }
      case 2:
      {
        dialog = "After the completion of each diagnostic, an individualized plan guides your student through a series of suggested lessons.";
        title = "Individualized Lesson Maps";
        break;
      }
      case 3:
      {
        dialog = "Students are provided with self-paced lessons. Basic subscribers receive a maximum of 15 lessons from their individualized plan. Premium subscribers have access to the complete individualized plan as well as all lessons from the course.";
        title = "Personalized On-Demand Lessons";
        break;
      }
      case 4:
      {
        dialog = "Students are provided lessons to target areas of improvement based on the diagnostic test. This is ideal for students who wish to review or improve competency in the subject matter.";
        title = "Remediation Approach";
        break;
      }
      case 5:
      {
        dialog = "A traditional learning approach in which all lessons are provided. This is ideal for students with no prior introduction to the subject matter or students who wish to review entire course.";
        title = "Extensive Approach";
        break;
      }
      case 6:
      {
        dialog = "Tests throughout the course that provide focused touchpoints on student learning progress.";
        title = "Unit Tests";
        break;
      }
      case 7:
      {
        dialog = "A report to follow student lesson progress as it relates to standards identified by the course diagnostic.";
        title = "Achievements Tracking";
        break;
      }
      default:
      {
        dialog = "";
        title = "";
        break;
      }
    }
    const dialogRef = this.dialog.open(SimplePopupDialogComponent, {
      data: {
        okString: "Ok",
        title: title,
        cancelString: null,
        dialog: dialog
      },
    });

    const sub = dialogRef.componentInstance.valueUpdated.subscribe(
      (yes) => {
        if(yes){

        }
      });

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  }



}
